import { render, staticRenderFns } from "./SerproConfig.vue?vue&type=template&id=5d3ad92e&"
import script from "./SerproConfig.vue?vue&type=script&lang=js&"
export * from "./SerproConfig.vue?vue&type=script&lang=js&"
import style0 from "./SerproConfig.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports